(function () {
    'use strict';
    var controllerId = 'contrattoAdd';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', '$uibModalInstance', 'datacontext', 'common', 'commerciali', 'societa', 'commercialeId', 'societaId', contrattoAdd]);

    function contrattoAdd($scope, $rootScope, $uibModalInstance, datacontext, common, commerciali, societa, commercialeId, societaId) {
        $scope.contratto = {};        
        $scope.commerciali = commerciali;
        $scope.societa = societa;
        $scope.super = $rootScope.isAuthorized('SUPER');

        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
        };
        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        $scope.format = 'dd/MM/yyyy';

        if (commercialeId) {
            $scope.commercialeId = commercialeId;
            $scope.contratto.CommercialeId = commercialeId;
        }
        else {
            if (commerciali && commerciali.length == 1)
                $scope.contratto.CommercialeId = commerciali[0].Id;
        }

        if (societaId) {
            $scope.istitutoId = societaId;
            $scope.contratto.IstitutoId = societaId;
        }
        else {
            if (societa && societa.length == 1)
                $scope.contratto.IstitutoId = societa[0].Id;
        }

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.contratto)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };        

        function addItem(item) {
            return datacontext.contratto_add(item).then(function (data) {
                if (!data || data.Id == null || data.Id == 0) return null;
        		return data;
        	});
        }
    }
})();